import React, { Component } from "react";
import classNames from "classnames";
import { images } from "./theme";

// Slide heading: the small eyebrow label ("Your results", "About Employer
// Partner", ...), the title and an optional subtitle.
//
// This is rendered by the slide as the first thing inside its text column
// rather than by V2Page, so the heading and the copy below it are one block.
// Keeping them separate made every two-column slide need its own vertical
// alignment fix, because the column was centring against the page instead of
// against the text it belongs to.
export const V2Header = ({ eyebrow, title, subtitle }) => {
  if (!eyebrow && !title && !subtitle) {
    return null;
  }

  return (
    <header className="report-v2__header">
      {eyebrow && <p className="report-v2__eyebrow">{eyebrow}</p>}
      {title && (
        <h2
          className="report-v2__title"
          dangerouslySetInnerHTML={{ __html: title }}
        />
      )}
      {subtitle && (
        <p
          className="report-v2__subtitle"
          dangerouslySetInnerHTML={{ __html: subtitle }}
        />
      )}
    </header>
  );
};

// Page shell for the V2 report.
//
// Every V2 slide is one of three kinds:
//   default - white page with the pale hexagon watermark
//   dark    - full-bleed gradient divider slide
//   plain   - white page with no watermark (chart-heavy pages)
//
// `number` is the page number printed in the bottom right corner. Headings are
// rendered by the slide with V2Header, inside the column they belong to.
export default class V2Page extends Component {
  render() {
    const {
      variant = "default",
      // Extra BEM modifier for slide-specific tweaks, e.g. "index" adds
      // .report-v2__page--index.
      modifier,
      background,
      number,
      id,
      children,
    } = this.props;

    const isDark = variant === "dark";
    // "plain" is a white slide with no watermark - used where the artwork on the
    // slide carries the design on its own.
    const watermark =
      variant === "plain"
        ? null
        : background ||
          (variant === "default" ? images.hexLight : null) ||
          (variant === "hex-left" ? images.hexLeft : null);

    return (
      <div className="report__page__wrapper" id={id}>
        <div
          className={classNames("report-v2__page", {
            "report-v2__page--dark": isDark,
            [`report-v2__page--${modifier}`]: modifier,
          })}
          style={
            isDark
              ? { backgroundImage: `url(${background || images.dividerDark})` }
              : watermark
                ? { backgroundImage: `url(${watermark})` }
                : undefined
          }
        >
          {children}
          {number !== undefined && (
            <span className="report-v2__page-number">{number}</span>
          )}
        </div>
      </div>
    );
  }
}
